const modal = new GraphModal({
    isOpen: (modal) => {
        console.log(modal);
        console.log('opened');
    },
});
